import { Col, notification, Row, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import {
  CONTRACT_ROUTE_PATH,
  DETAILS_ROUTE_PATH,
  FINISH_ROUTE_PATH,
} from '../App'
import { AuthorName, Cover } from '../components'
import { useAuth } from '../context/AuthProvider'
import { useUploadProcess } from '../context/UploadProcessProvider'
import { StepsPage } from '../structure'
const { Title, Paragraph } = Typography

const STEP_NUMBER = 2
const DETAILS_TAB_NUMBER = 0
const NAME = 1
const PSEUDONYM = 2
const ANONYMUS = 3

const Author = () => {
  const { t } = useTranslation()
  const { data, setValues, getSubmission, updateSubmission } =
    useUploadProcess()
  const { getUserNames } = useAuth()
  const { firstName, lastName } = getUserNames()
  const [authorType, setAuthorType] = useState(NAME)
  const [authorFirstName, setAuthorFirstName] = useState(firstName)
  const [authorLastName, setAuthorLastName] = useState(lastName)

  const params = useParams()
  const id = parseInt(params.id)
  const submission_id = parseInt(params.submission_id)
  const navigate = useNavigate()

  useEffect(() => {
    if (data.contract_option === null) {
      redirectTo(CONTRACT_ROUTE_PATH)
    }
    if (!data.draft) {
      redirectTo(FINISH_ROUTE_PATH)
      return
    }
    getSubmission(
      submission_id,
      (response) => {
        if (!response) return
        if (response.published || !response['draft']) {
          displayError(t('Finished.TextReady'))
          redirectTo(FINISH_ROUTE_PATH)
          return
        }
        setValues({
          id: id,
          title: response.title,
          draft: response['draft'],
        })
        if (response.contributors?.length) {
          const author = response.contributors[0]
          if (
            author.first_name === firstName &&
            author.last_name === lastName
          ) {
            setAuthorType(NAME)
          } else {
            setAuthorType(PSEUDONYM)
          }
          setAuthorFirstName(author.first_name)
          setAuthorLastName(author.last_name)
        }
      },
      (result) => {
        displayError(result.statusText)
      }
    )
  }, [])

  const displayError = (message) => {
    notification.warning({
      message: t(message),
      placement: 'bottomLeft',
    })
  }

  const setContributors = async (contributors, onSuccess) => {
    updateSubmission(
      submission_id,
      { contributors: contributors },
      onSuccess,
      (status) => {
        displayError(status)
      }
    )
  }
  const handleAuthorChange = (changedFields, allFields) => {
    const authorType = allFields[2].value
    if (authorType === ANONYMUS) {
      setAuthorFirstName('')
      setAuthorLastName(t('Author.Anonymous.title'))
    } else if (authorType === PSEUDONYM) {
      setAuthorFirstName(allFields[0].value || '')
      setAuthorLastName(allFields[1].value || '')
    } else {
      setAuthorFirstName(firstName)
      setAuthorLastName(lastName)
    }
    setAuthorType(authorType)
    setValues({ author: [authorFirstName, authorLastName].join(' ') })
  }
  const handleAuthorSave = (values) => {
    const onSuccess = () => {
      redirectTo(DETAILS_ROUTE_PATH)
    }
    setContributors(
      [
        {
          first_name: authorFirstName,
          last_name: authorLastName,
          link_to_profile: ![PSEUDONYM, ANONYMUS].includes(values.type),
          unnamed_persons_code: values.type === ANONYMUS ? '02' : null,
        },
      ],
      onSuccess
    )
  }

  const redirectTo = (path) => {
    navigate(path.replace(':submission_id', submission_id).replace(':id', id))
  }

  return (
    <StepsPage
      step={STEP_NUMBER}
      tab={DETAILS_TAB_NUMBER}
      title={t('Author.ChooseName')}
      className="details-author"
    >
      <Paragraph style={{ marginTop: '-24px' }}>
        {t('Author.NamePublication')}
      </Paragraph>
      <br className="show-on-desktop" />
      <br className="show-on-desktop" />
      <Row gutter={{ sm: 0, xl: 90 }}>
        <Col xs={24} sm={14} xl={14}>
          <Title level={3}>{t('Author.PublishText')}</Title>
          <br />
          <AuthorName
            type={authorType}
            firstName={authorFirstName}
            lastName={authorLastName}
            onAuthorChange={handleAuthorChange}
            onSubmit={handleAuthorSave}
          />
        </Col>
        <Col sm={8} xl={10} className="show-on-desktop">
          <Cover
            author={authorFirstName + ' ' + authorLastName}
            title={data.title}
          />
        </Col>
      </Row>
    </StepsPage>
  )
}
export default Author
